import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  Typography,
  Card,
  Box,
  Switch,
  Stack,
  Grid,
  Checkbox,
  Paper,
  Button,
  Hidden,
  TextField,
  IconButton,
  Snackbar,
  CardContent,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import {
  BootstrapDialog,
  BootstrapDialogTitle,
} from "../../reusableComponent/BootstrapDialog";
import DialogContent from "@mui/material/DialogContent";
import { Icon } from "@iconify/react";
import SaveIcon from "@mui/icons-material/Save";
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import styles from ".././../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addInvoiceSetting,
  editInvoiceSetting,
  getInvoiceSettingList,
} from "../../../actions/actions";
import { dateConversionOnEntryPageWithTime } from "../../reusableComponent/dateConversionOnEntryPage";
import { BackBtn } from "../../reusableComponent/BackBtn";

const InvoiceSetting = (props) => {
  const { handleSubmit } = useForm();
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
  let navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(null);

  const [itemFromItemMaster, setItemFromItemMaster] = useState();
  const [itemFromSalesOrder, setItemFromSalesOrder] = useState();
  const [itemThroughManualEntry, setItemThroughManualEntry] = useState();
  const [showPartyBalance, setShowPartyBalance] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [showItemDescription, setShowItemDescription] = useState(false);
  const [showBatchNo, setShowBatchNo] = useState(false);
  const [showDRGNo, setShowDRGNo] = useState(false);
  const [showNoOfPKG, setShowNoOfPKG] = useState(false);
  const [showEWayBillNo, setShowEWayBillNo] = useState(false);
  const [showVehicleNo, setShowVehicleNo] = useState(false);
  const [showTransportName, setShowTransportName] = useState(false);
  const [showTransportMode, setShowTransportMode] = useState(false);
  const [showAsnNo, setShowAsnNo] = useState(false);
  const [showAccountName, setShowAccountName] = useState(false);
  const [showPaymentTerms, setShowPaymentTerms] = useState(false);
  const [showContactPerson, setShowContactPerson] = useState(false);
  const [showDiscountPer_details, setShowDiscountPer_details] = useState(false);
  const [showDiscountPer_header, setShowDiscountPer_header] = useState(false);
  const [showGstPer_details, setShowGstPer_details] = useState(false);
  const [showGstPer_header, setShowGstPer_header] = useState(false);
  const [showPackingForwarding, setShowPackingForwarding] = useState(false);
  const [showFreightCharges, setShowFreightCharges] = useState(false);
  const [showTempoCharges, setShowTempoCharges] = useState(false);
  const [showOtherCharges, setShowOtherCharges] = useState(false);
  const [showRoundOff, setShowRoundOff] = useState(false);
  const [showPackingForwardingGSTApplicable, setShowPackingForwardingGSTApplicable] = useState(false);
  const [showFreightChargesGSTApplicable, setShowFreightChargesGSTApplicable] = useState(false);
  const [showTempoChargesGSTApplicable, setShowTempoChargesGSTApplicable] = useState(false);
  const [showOtherChargesGSTApplicable, setShowOtherChargesGSTApplicable] = useState(false);

  const rows = useSelector((state) => state.invoiceSetting.invoiceSetting);

  const fetchData = () => {
    dispatch(getInvoiceSettingList({ companyId: userInfo.companyId }));
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleChangeItemFromItemMaster = (event) => {
    setItemFromItemMaster(event.target.checked);
    if (event.target.checked === true) {
      setItemFromSalesOrder(false);
      setItemThroughManualEntry(false);
    }
  };
  const handleChangeItemFromSalesOrder = (event) => {
    setItemFromSalesOrder(event.target.checked);
    if (event.target.checked === true) {
      setItemFromItemMaster(false);
      setItemThroughManualEntry(false);
    }
  };

  const handleChangeItemThroughManualEntry = (event) => {
    setItemThroughManualEntry(event.target.checked);
    if (event.target.checked === true) {
      setItemFromSalesOrder(false);
      setItemFromItemMaster(false);
    }
  };

  const handleChangeShowPartyBalance = (event) => {
    setShowPartyBalance(event.target.checked);
  };
  const handleChangeShowBankDetails = (event) => {
    setShowBankDetails(event.target.checked);
  };
  const handleChangeShowItemDescription = (event) => {
    setShowItemDescription(event.target.checked);
  };
  const handleChangeShowBatchNo = (event) => {
    setShowBatchNo(event.target.checked);
  };
  const handleChangeShowDRGNo = (event) => {
    setShowDRGNo(event.target.checked);
  };
  const handleChangeShowNoOfPKG = (event) => {
    setShowNoOfPKG(event.target.checked);
  };
  const handleChangeShowDiscountPer_details = (event) => {
    setShowDiscountPer_details(event.target.checked);
    // if (event.target.checked === true) {
    //   setShowDiscountPer_header(false);
    // } else {
    //   setShowDiscountPer_header(true);
    // }
  };
  const handleChangeShowDiscountPer_header = (event) => {
    setShowDiscountPer_header(event.target.checked);
    // if (event.target.checked === true) {
    //   setShowDiscountPer_details(false);
    // } else {
    //   setShowDiscountPer_details(true);
    // }

  };
  const handleChangeShowGstPer_details = (event) => {
    setShowGstPer_details(event.target.checked);
    if (event.target.checked === true) {
      setShowGstPer_header(false);
    } else {
      setShowGstPer_header(true);
    }
  };
  const handleChangeShowGstPer_header = (event) => {
    setShowGstPer_header(event.target.checked);
    if (event.target.checked === true) {
      setShowGstPer_details(false);
    } else {
      setShowGstPer_details(true);
    }
  };
  const handleChangeShowPackingForwarding = (event) => {
    setShowPackingForwarding(event.target.checked);
  };
  const handleChangeShowFreightCharges = (event) => {
    setShowFreightCharges(event.target.checked);
  };
  const handleChangeShowTempoCharges = (event) => {
    setShowTempoCharges(event.target.checked);
  };
  const handleChangeShowOtherCharges = (event) => {
    setShowOtherCharges(event.target.checked);
  };
  const handleChangeShowEWayBillNo = (event) => {
    setShowEWayBillNo(event.target.checked);
  };
  const handleChangeShowVehicleNo = (event) => {
    setShowVehicleNo(event.target.checked);
  };
  const handleChangeShowTransportName = (event) => {
    setShowTransportName(event.target.checked);
  };
  const handleChangeShowTransportMode = (event) => {
    setShowTransportMode(event.target.checked);
  };
  const handleChangeShowAsnNo = (event) => {
    setShowAsnNo(event.target.checked);
  };
  const handleChangeShowAccountName = (event) => {
    setShowAccountName(event.target.checked);
  };
  const handleChangeShowPaymentTerms = (event) => {
    setShowPaymentTerms(event.target.checked);
  };
  const handleChangeShowContactPerson = (event) => {
    setShowContactPerson(event.target.checked);
  };
  const handleChangeShowRoundOff = (event) => {
    setShowRoundOff(event.target.checked);
  };
  const handleChangeShowPackingForwardingGSTApplicable = (event) => {
    setShowPackingForwardingGSTApplicable(event.target.checked);
  };
  const handleChangeShowFreightChargesGSTApplicable = (event) => {
    setShowFreightChargesGSTApplicable(event.target.checked);
  };
  const handleChangeShowTempoChargesGSTApplicable = (event) => {
    setShowTempoChargesGSTApplicable(event.target.checked);
  };
  const handleChangeShowOtherChargesGSTApplicable = (event) => {
    setShowOtherChargesGSTApplicable(event.target.checked);
  };

  const [shouldShowMsg, setShouldShowMsg] = useState(false);
  const responseMessage = useSelector((state) => state.invoiceSetting.message);

  useEffect(() => {
    if (responseMessage) {
      setShouldShowMsg(true);
    }
  }, [responseMessage, dispatch]);

  useEffect(() => {
    if (shouldShowMsg) {
      if (responseMessage !== null) {
        setSuccessMessage(responseMessage);
        setShouldShowMsg(false);
        dispatch({ type: "RESET_MESSAGE" }); // Dispatch an action to reset the message
        fetchData();
      }
    }
  }, [shouldShowMsg, responseMessage, fetchData]);

  useEffect(() => {
    if (rows.length > 0) {
      setItemFromItemMaster(
        rows[0].itemFromItemMaster === "true" ? true : false
      );
      setItemFromSalesOrder(
        rows[0].itemFromSalesOrder === "true" ? true : false
      );
      setItemThroughManualEntry(
        rows[0].itemThroughManualEntry === "true" ? true : false
      );
      setShowPartyBalance(rows[0].showPartyBalance === "true" ? true : false);
      setShowBankDetails(rows[0].showBankDetails === "true" ? true : false);
      setShowItemDescription(
        rows[0].showItemDescription === "true" ? true : false
      );
      setShowBatchNo(rows[0].showBatchNo === "true" ? true : false);
      setShowDRGNo(rows[0].showDRGNo === "true" ? true : false);
      setShowNoOfPKG(rows[0].showNoOfPKG === "true" ? true : false);
      setShowEWayBillNo(rows[0].showEWayBillNo === "true" ? true : false);
      setShowVehicleNo(rows[0].showVehicleNo === "true" ? true : false);
      setShowTransportName(rows[0].showTransportName === "true" ? true : false);
      setShowTransportMode(rows[0].showTransportMode === "true" ? true : false);
      setShowAsnNo(rows[0].showAsnNo === "true" ? true : false);
      setShowAccountName(rows[0].showAccountName === "true" ? true : false);
      setShowPaymentTerms(rows[0].showPaymentTerms === "true" ? true : false);
      setShowContactPerson(rows[0].showContactPerson === "true" ? true : false);
      setShowDiscountPer_details(
        rows[0].showDiscountPer_details === "true" ? true : false
      );
      setShowDiscountPer_header(
        rows[0].showDiscountPer_header === "true" ? true : false
      );
      setShowGstPer_details(
        rows[0].showGstPer_details === "true" ? true : false
      );
      setShowGstPer_header(
        rows[0].showGstPer_header === "true" ? true : false
      );
      setShowPackingForwarding(
        rows[0].showPackingForwarding === "true" ? true : false
      );
      setShowFreightCharges(
        rows[0].showFreightCharges === "true" ? true : false
      );
      setShowTempoCharges(rows[0].showTempoCharges === "true" ? true : false);
      setShowOtherCharges(rows[0].showOtherCharges === "true" ? true : false);
      setShowRoundOff(rows[0].showRoundOff === "true" ? true : false);
      setShowPackingForwardingGSTApplicable(rows[0].showPackingForwardingGSTApplicable === "true" ? true : false);
      setShowFreightChargesGSTApplicable(rows[0].showFreightChargesGSTApplicable === "true" ? true : false);
      setShowTempoChargesGSTApplicable(rows[0].showTempoChargesGSTApplicable === "true" ? true : false);
      setShowOtherChargesGSTApplicable(rows[0].showOtherChargesGSTApplicable === "true" ? true : false);
    }
  }, [rows]);

  const handleCloseSuccessMsg = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessMessage(false);
  };

  const onSubmit = (event) => {
    let sending_data = {
      companyId: userInfo.companyId,
      id: rows.length > 0 ? rows[0].id : null,
      itemFromItemMaster: itemFromItemMaster,
      itemFromSalesOrder: itemFromSalesOrder,
      itemThroughManualEntry: itemThroughManualEntry,
      showPartyBalance: showPartyBalance,
      showBankDetails: showBankDetails,
      showItemDescription: showItemDescription,
      showBatchNo: showBatchNo,
      showDRGNo: showDRGNo,
      showNoOfPKG: showNoOfPKG,
      showEWayBillNo: showEWayBillNo,
      showVehicleNo: showVehicleNo,
      showTransportName: showTransportName,
      showTransportMode: showTransportMode,
      showAsnNo: showAsnNo,
      showAccountName: showAccountName,
      showPaymentTerms: showPaymentTerms,
      showContactPerson: showContactPerson,
      showDiscountPer_details: showDiscountPer_details,
      showDiscountPer_header: showDiscountPer_header,
      showGstPer_details: showGstPer_details,
      showGstPer_header: showGstPer_header,
      showPackingForwarding: showPackingForwarding,
      showFreightCharges: showFreightCharges,
      showTempoCharges: showTempoCharges,
      showOtherCharges: showOtherCharges,
      showRoundOff: showRoundOff,
      showPackingForwardingGSTApplicable: showPackingForwardingGSTApplicable,
      showFreightChargesGSTApplicable: showFreightChargesGSTApplicable,
      showTempoChargesGSTApplicable: showTempoChargesGSTApplicable,
      showOtherChargesGSTApplicable: showOtherChargesGSTApplicable,
      createdBy: rows.length > 0 ? rows[0].createdBy : userInfo.userId,
      createdAt:
        rows.length > 0
          ? rows[0].createdAt
          : dateConversionOnEntryPageWithTime(new Date()),
      modifiedBy: rows.length > 0 ? userInfo.userId : null,
      modifiedAt:
        rows.length > 0 ? dateConversionOnEntryPageWithTime(new Date()) : "",
    };
    if (rows.length > 0) {
      dispatch(editInvoiceSetting(sending_data));
    } else {
      dispatch(addInvoiceSetting(sending_data));
    }
  };

  const actionMsg = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSuccessMsg}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleClick = () => {
    const value = props.value - 1;
    props.onValueReceived(value);
  };

  return (
    <>
      <Breadcrumb
        routeSegments={[
          { name: "Settings", path: "/settings" },
          { name: "Create Invoice Fields Setting" },
        ]}
      />
      <Paper className={`${styles.list_container}`}>
        {/* <Box sx={{ display: 'flex', paddingLeft: '50px' }}>
                <Grid container spacing={0.2} sx={{ mt: 2, pb: 2 }}>
                    <Grid item md={12} xs={12}>
                        <Typography className={`${styles.page_title}`}>Create Invoice Fields Setting</Typography>
                    </Grid>
                </Grid>
            </Box> */}

        <Grid container spacing={1} sx={{ paddingLeft: "50px", mt: 2 }}>
          <Grid item xs={3}>
            <Typography className={`${styles.erp_lable}`}>
              {" "}
              Create Invoice Fields Setting in regard to the fields that you may
              require in the invoice form. make entry for the printing options
              also.
            </Typography>
          </Grid>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderRightWidth: 2, minHeight: 200 }}
          />
          <Grid item xs={8.8} style={{}}>
            <Box sx={{ width: "100%" }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={1} sx={{ pl: 2 }}>
                  <Grid item xs={6}>
                    <Grid container spacing={1} sx={{ marginTop: -1.5 }}>
                      <Grid item xs={12}>
                        <Typography className={`${styles.erp_lable}`}>
                          <u><b>Invoice Header Settings </b></u>
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Discount Percent
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) =>
                              handleChangeShowDiscountPer_header(e)
                            }
                            name="showDiscountPer_header"
                            value={showDiscountPer_header}
                            checked={showDiscountPer_header}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show GST Percent
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) =>
                              handleChangeShowGstPer_header(e)
                            }
                            name="showGstPer_header"
                            value={showGstPer_header}
                            checked={showGstPer_header}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show E-Way Bill No.
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowEWayBillNo(e)}
                            name="showEWayBillNo"
                            value={showEWayBillNo}
                            checked={showEWayBillNo}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Vehicle No.
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowVehicleNo(e)}
                            name="showVehicleNo"
                            value={showVehicleNo}
                            checked={showVehicleNo}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Transport Name
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowTransportName(e)}
                            name="showTransportName"
                            value={showTransportName}
                            checked={showTransportName}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show LR No
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowTransportMode(e)}
                            name="showTransportMode"
                            value={showTransportMode}
                            checked={showTransportMode}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show ASN No.
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowAsnNo(e)}
                            name="showAsnNo"
                            value={showAsnNo}
                            checked={showAsnNo}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Account name
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowAccountName(e)}
                            name="showAccountName"
                            value={showAccountName}
                            checked={showAccountName}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Payment Terms
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowPaymentTerms(e)}
                            name="showPaymentTerms"
                            value={showPaymentTerms}
                            checked={showPaymentTerms}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Contact Person
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowContactPerson(e)}
                            name="showContactPerson"
                            value={showContactPerson}
                            checked={showContactPerson}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Packing & Forwarding
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) =>
                              handleChangeShowPackingForwarding(e)
                            }
                            name="showPackingForwarding"
                            value={showPackingForwarding}
                            checked={showPackingForwarding}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Packing & Forwarding GST Applicable?
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowPackingForwardingGSTApplicable(e)}
                            name="showPackingForwardingGSTApplicable"
                            value={showPackingForwardingGSTApplicable}
                            checked={showPackingForwardingGSTApplicable}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Freight Charges
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowFreightCharges(e)}
                            name="showFreightCharges"
                            value={showFreightCharges}
                            checked={showFreightCharges}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Freight Charges GST Applicable?
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowFreightChargesGSTApplicable(e)}
                            name="showFreightChargesGSTApplicable"
                            value={showFreightChargesGSTApplicable}
                            checked={showFreightChargesGSTApplicable}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Tempo Charges
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowTempoCharges(e)}
                            name="showTempoCharges"
                            value={showTempoCharges}
                            checked={showTempoCharges}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Tempo Charges GST Applicable?
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowTempoChargesGSTApplicable(e)}
                            name="showTempoChargesGSTApplicable"
                            value={showTempoChargesGSTApplicable}
                            checked={showTempoChargesGSTApplicable}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Other Charges
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowOtherCharges(e)}
                            name="showOtherCharges"
                            value={showOtherCharges}
                            checked={showOtherCharges}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Other Charges GST Applicable?
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowOtherChargesGSTApplicable(e)}
                            name="showOtherChargesGSTApplicable"
                            value={showOtherChargesGSTApplicable}
                            checked={showOtherChargesGSTApplicable}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Round Off
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowRoundOff(e)}
                            name="showRoundOff"
                            value={showRoundOff}
                            checked={showRoundOff}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>

                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container spacing={1} sx={{}}>
                      <Grid item xs={12}>
                        <Typography className={`${styles.erp_lable}`}>
                          <u>
                            {" "}
                            <b> Item Selection </b>
                          </u>
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          From Item Master
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <>
                            <Switch
                              size="small"
                              onChange={(e) =>
                                handleChangeItemFromItemMaster(e)
                              }
                              name="itemFromItemMaster"
                              value={itemFromItemMaster}
                              checked={itemFromItemMaster}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          </>
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          From Sales Order
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeItemFromSalesOrder(e)}
                            name="itemFromSalesOrder"
                            value={itemFromSalesOrder}
                            checked={itemFromSalesOrder}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Manual Entry
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) =>
                              handleChangeItemThroughManualEntry(e)
                            }
                            name="itemThroughManualEntry"
                            value={itemThroughManualEntry}
                            checked={itemThroughManualEntry}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={12} style={{ marginTop: "10px" }}>
                        <Typography className={`${styles.erp_lable}`}>
                          <u>
                            {" "}
                            <b>Invoice Setting </b>
                          </u>
                        </Typography>
                      </Grid>

                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Party Balance in Invoice
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowPartyBalance(e)}
                            name="showPartyBalance"
                            value={showPartyBalance}
                            checked={showPartyBalance}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Bank Details in Invoice
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowBankDetails(e)}
                            name="showBankDetails"
                            value={showBankDetails}
                            checked={showBankDetails}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={12} style={{ marginTop: "10px" }}>
                        <Typography className={`${styles.erp_lable}`}>
                          <u>
                            {" "}
                            <b>Invoice Details Setting </b>
                          </u>
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Item Description
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowItemDescription(e)}
                            name="showItemDescription"
                            value={showItemDescription}
                            checked={showItemDescription}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          show Batch No.
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowBatchNo(e)}
                            name="showBatchNo"
                            value={showBatchNo}
                            checked={showBatchNo}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show DRG No.
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowDRGNo(e)}
                            name="showDRGNo"
                            value={showDRGNo}
                            checked={showDRGNo}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show No. of PKG
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) => handleChangeShowNoOfPKG(e)}
                            name="showNoOfPKG"
                            value={showNoOfPKG}
                            checked={showNoOfPKG}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Discount Percent
                        </Typography>
                      </Grid>

                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) =>
                              handleChangeShowDiscountPer_details(e)
                            }
                            name="showDiscountPer_details"
                            value={showDiscountPer_details}
                            checked={showDiscountPer_details}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={`${styles.erp_lable}`}>
                          Show Gst Percent
                        </Typography>
                      </Grid>

                      <Grid item xs={4}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography className={`${styles.erp_lable}`}>
                            No
                          </Typography>
                          <Switch
                            size="small"
                            onChange={(e) =>
                              handleChangeShowGstPer_details(e)
                            }
                            name="showGstPer_details"
                            value={showGstPer_details}
                            checked={showGstPer_details}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <Typography className={`${styles.erp_lable}`}>
                            Yes
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Box sx={{ marginTop: "12px", float: "right" }}>
                  <Button
                    color="primary"
                    id={`${styles.btn_save}`}
                    variant="contained"
                    type="submit"
                  >
                    <SaveIcon
                      style={{ fontSize: "16px", marginRight: "10px" }}
                    />{" "}
                    {rows.length > 0 ? "Update" : "Save"}
                  </Button>
                </Box>
              </form>
            </Box>
          </Grid>
        </Grid>

        {successMessage && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={successMessage ? true : false}
            autoHideDuration={1000}
            onClose={handleCloseSuccessMsg}
            message={successMessage}
            action={actionMsg}
          />
        )}
      </Paper>
    </>
  );
};
export default InvoiceSetting;
